import { render, staticRenderFns } from "./CriteriasPanel.vue?vue&type=template&id=0ef5f780&"
import script from "./CriteriasPanel.vue?vue&type=script&lang=js&"
export * from "./CriteriasPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports